<div class="child-container" *ngFor="let child of user?.children">
  <div class="child-content">
    <div class="content-left">
      <div class="child-image">
        <img class="avatar" src="{{ child.photo }}" alt="avatar" />
      </div>
    </div>

    <div class="content-right">
      <div class="child-name">
        <span class="child-name-text title-color">
          {{ child.firstName }} {{ child.lastName }}
        </span>
      </div>
      <div class="child-ra" *ngIf="child.ra">
        <span class="child-ra-text title-color">
          Matricula: {{ child.ra }}
        </span>
      </div>
      <div
        class="child-segment"
        *ngFor="let classRoom of child?.classRooms; index as i"
      >
        <span *ngIf="classRoom">
          {{ classRoom.year }}
        </span>
        <span *ngIf="classRoom.segment">
          - {{ classRoom.segment.name }}
        </span>
        <span *ngIf="classRoom.serie"> - {{ classRoom.serie.name }} </span>
        <span *ngIf="classRoom"> - {{ classRoom.name }} </span>
      </div>
    </div>
  </div>
</div>